export let DATABASE_SCHEMA = "";

const BACKEND_BASE_URL_LOCAL = "http://localhost:8081/";
const BACKEND_BASE_URL_IP = "http://10.202.21.180:7002/be-advised/";
const BACKEND_BASE_URL_PRODUCTION = "https://myadvice.amanahapp.run/be-advised/";
const BACKEND_BASE_URL_RHEL_AMANAH = "https://rhel-amanah.netbird.cloud/be-advised/";
function getBackendBaseUrls() {
  const pageHost = window.location.hostname.toLowerCase();

  if (pageHost === "localhost" || pageHost === "127.0.0.1") {
    return [BACKEND_BASE_URL_LOCAL];
  }

  if (pageHost === "10.202.21.174") {
    return [BACKEND_BASE_URL_IP];
  }

  if (pageHost === "beadvised" || pageHost.startsWith("beadvised.")) {
    return [BACKEND_BASE_URL_PRODUCTION, BACKEND_BASE_URL_RHEL_AMANAH];
  }

  return [BACKEND_BASE_URL_PRODUCTION, BACKEND_BASE_URL_RHEL_AMANAH];
}

export async function loadRuntimeConfig() {
  const failures = [];

  for (const baseUrl of getBackendBaseUrls()) {
    const url = `${baseUrl.replace(/\/$/, "")}/runtime-config`;

    try {
      const response = await fetch(url, {
        cache: "no-store",
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const contentType = response.headers.get("content-type") || "unknown content type";
      if (!contentType.toLowerCase().includes("application/json")) {
        throw new Error(`expected JSON, received ${contentType}`);
      }

      const config = await response.json();
      const schema = String(config?.databaseSchema || "").trim().toUpperCase();
      if (!schema) {
        throw new Error("backend runtime config did not provide databaseSchema");
      }

      DATABASE_SCHEMA = schema;
      return;
    } catch (error) {
      failures.push(`${url}: ${error?.message || "request failed"}`);
    }
  }

  throw new Error(`Backend runtime config gagal dimuat. ${failures.join(" | ")}`);
}
